//TODO : reuse from one place.
// needs to be used in myop-sdk, myop-dashbaord, myop-server, myop-cli ..

export const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

// Convert UUID string to bytes
export const uuidToBytes = (uuid: string): Uint8Array => {
    return Uint8Array.from(
        uuid.replace(/-/g, '').match(/.{1,2}/g)!.map(byte => parseInt(byte, 16))
    );
};

// Convert bytes to UUID string
export const bytesToUuid = (bytes: Uint8Array): string => {
    const hex = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
    return [
        hex.slice(0, 8),
        hex.slice(8, 12),
        hex.slice(12, 16),
        hex.slice(16, 20),
        hex.slice(20)
    ].join('-');
};

// Base64 URL-safe encode
export const base64UrlEncode = (bytes: Uint8Array): string => {
    const base64 = btoa(String.fromCharCode(...bytes));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

// Base64 URL-safe decode
export const base64UrlDecode = (str: string): Uint8Array => {
    let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';
    const binary = atob(base64);
    return Uint8Array.from(binary, char => char.charCodeAt(0));
};

// Compress an array of UUIDs into a short URL-safe string
export const compressUUIDs = (uuids: string[]): string => {
    const allBytes = uuids.flatMap(uuid => Array.from(uuidToBytes(uuid)));
    return base64UrlEncode(new Uint8Array(allBytes));
};

// Decompress from URL-safe string back to an array of UUIDs
export const decompressUUIDs = (encoded: string): string[] => {
    const bytes = base64UrlDecode(encoded);
    if (bytes.length % 16 !== 0) throw new Error('Invalid input length');

    const uuids: string[] = [];
    for (let i = 0; i < bytes.length; i += 16) {
        uuids.push(bytesToUuid(bytes.slice(i, i + 16)));
    }
    return uuids;
};
